import React, {Component} from 'react';
import HomeCar from "../../assets/images/car/car.png"
import Engine from "../../assets/images/car/engine.png"
import LoadingCog from "../../assets/images/car/loading-cog.gif"
import HomeCarLight from "../../assets/images/car/car-light.png"
import HomeCarDoor from "../../assets/images/car/car-door.png"
import HomeCarDoorLight from "../../assets/images/car/car-door-light.png"
import PowerBTN from "../../assets/images/powerbtn.png"
import Loading from "../Common/Loading";
import Navbar from "../Common/Navbar";
import { FaRoute, FaSatelliteDish,} from 'react-icons/fa';
import { BiWifi, } from "react-icons/bi";
//import moment from "moment-timezone";


import {
    BsSpeedometer2,
    CiBluetooth, CiLock,
    CiUnlock,
    CiVolumeMute, FaAngleLeft,
    GiTwoCoins,
    HiOutlineEnvelope,
    HiOutlineLocationMarker,
    IoCarSport, IoHammerSharp,
    IoVolumeMute,
    RxLockClosed,
    RxLockOpen1,
    TbBatteryAutomotive,
    TbCarCrash, TbCircuitSwitchClosed,
    TbCircuitSwitchOpen,

} from "react-icons/all";
import API from "../../services/API";
import {toast} from "react-toastify";
import Toast from "../Common/Toast";

const currencyFormat = Intl.NumberFormat('en-US');
let timer = null;

let callServiceInterval = 0;

class Home extends Component {

    state = {
        cars: [],
        isLoaded: false,
        showModalPower: false,
        activeCar: window.localStorage.getItem("_ac" ),
        engineRun: false,
        connection_type : window.localStorage.getItem("connection_type"),
    }

    touchStart = (e) => {
        e.preventDefault();
        e.target.style.height = '95px'
        this.setState({'engineRun' : true})
        if (!timer) {
            timer = setTimeout(() => {
                clearTimeout(timer);
                timer = null;
                e.target.style.height = '100px'
                this.setState({'engineRun' : false})
                const command = this.state.cars[this.state.activeCar].start  > 0 ? 'sof' : `son`;
                this.sendToSocket(command);
            }, 3200)
        }
    }

    touchEnd = (e) => {
        if (timer) {
            e.target.style.height = '100px'
            this.setState({'engineRun' : false})
            toast.warn('برای روشن (یا خاموش) کردن خودرو ۳ ثانیه دست خود را روی دکمه نگه دارید')
            clearTimeout(timer);
            timer = null;
        }
    }

    sendToSocket = (command) => {

        const ConnectionType = window.localStorage.getItem("connection_type");
        if(ConnectionType === 'internet') {
            const request = {
                'mobile': this.state.cars[this.state.activeCar].main_phone,
                'device': this.state.cars[this.state.activeCar].car_code,
                'password': window.localStorage.getItem("password"),
                'command': command
            };
            this.setState({isLoaded: false})
            API.socketSendData(request)
                .then((response) => {
                    toast.success('دستور با موفقیت به دستگاه ارسال شد');
                    const mobile = window.localStorage.getItem("mobile");
                    const password = window.localStorage.getItem("password");

                    API.getCarData(mobile,password)
                        .then((response) => {
                            this.setState({isLoaded: true, 'cars': response.car_act})

                        })
                })

        }
        else {

            let check = false;
            (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
            if(!check) {
                toast.error('شما در حال استفاده در کامپیوتر هستید، امکان ارسال پیامک با استفاده از کامپیوتر وجود ندارد. لطفا نحوه ارتباط را به حالت اینترنتی تغییر دهید ');
                return false;
            }
            let body = '*' + command + '#';

            if (navigator.userAgent.match(/Android/i)) {
                window.open(`sms://${this.state.cars[this.state.activeCar].phone_device}/?body=${body}`);

            }
            if (navigator.userAgent.match(/iPhone/i)) {
                window.open(`sms://${this.state.cars[this.state.activeCar].phone_device}/&body=${body}`);
            }
        }

    }

    sendLocationSMS = () => {
        let body = 'موقعیت';

        if (navigator.userAgent.match(/Android/i)) {
            window.open(`sms://${this.state.cars[this.state.activeCar].phone_device}/?body=${body}`);

        }
        if (navigator.userAgent.match(/iPhone/i)) {
            window.open(`sms://${this.state.cars[this.state.activeCar].phone_device}/&body=${body}`);
        }
    }
    render() {
        let carType = '';
        let diff = 100;
        if(this.state.isLoaded) {


          //  const now = moment(d.getHours() + ':' + d.getMinutes() );
            let carTime =  this.state.cars[this.state.activeCar].time ;
            carTime = carTime?.split(":");

            const d = new Date();
            diff = ((d.getHours() - carTime[0]) * 60 ) - -(d.getMinutes()-carTime[1]) ;

            carType =   this.state.cars[this.state.activeCar].car_code.charAt(0).toUpperCase() ;
        }


        return (
            <React.Fragment>
                <Toast/>
                {
                    !this.state.isLoaded && <Loading />
                }

                {
                    this.state.showModalPower &&
                    <section className="container-fluid modal-bg max-w-lg">
                        <div className="row rtl">
                            <div className="col-12">
                                <div className="row modal-card">
                                    <div className="col-12 text-white text-center py-3 fw-bold">
                                        Power
                                    </div>
                                    <div className="col-12">
                                        <div className="row btn-row"
                                             onClick={
                                                 () => {
                                                     const command = `caron`;
                                                     this.sendToSocket(command);
                                                     this.setState({showModalPower: false})
                                                 }
                                             }
                                        >
                                            <div className="col-2">
                                                <TbCircuitSwitchClosed className='ms-2 text-big-2  text-primary-color' />
                                            </div>
                                            <div className="col-9 text-white">
                                               اجازه روشن شدن خودرو
                                            </div>
                                            <div className="col-1">
                                                <FaAngleLeft className="text-primary-color" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="row btn-row"
                                             onClick={
                                                 () => {
                                                     const command = `caroff`;
                                                     this.sendToSocket(command);
                                                     this.setState({showModalPower: false})
                                                 }
                                             }
                                        >
                                            <div className="col-2">
                                                <TbCircuitSwitchOpen className='ms-2 text-big-2  text-danger' />
                                            </div>
                                            <div className="col-9 text-white">
                                               خاموش کردن خودرو
                                            </div>
                                            <div className="col-1">
                                                <FaAngleLeft className="text-primary-color" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="row btn-row"
                                             onClick={
                                                 () => {
                                                     const command = `carofs`;
                                                     this.sendToSocket(command);
                                                     this.setState({showModalPower: false})
                                                 }
                                             }
                                        >
                                            <div className="col-2">
                                                <TbCircuitSwitchOpen className='ms-2 text-big-2  text-danger' />
                                            </div>
                                            <div className="col-9 text-white">
                                                خاموش کردن خودرو زیر سرعت 30KM
                                            </div>
                                            <div className="col-1">
                                                <FaAngleLeft className="text-primary-color" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 my-2">


                                        <button className='btn bg-dark text-white text-small-1 w-100 p-2 '

                                                onClick={() => {
                                                    this.setState({showModalPower: false})
                                                }}
                                        >

                                            انصراف
                                        </button>



                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                }

                <section className="container px-4 pt-2 rtl">
                    <div className="row home-top-part my-3 ">
                        <div className="col-6 link text-right"
                        onClick={
                            () => {
                                window.location.assign('http://gps.telcarnet.com?mobile='+window.localStorage.getItem("mobile"))
                                window.localStorage.setItem("_trk" , 93 )
                                //window.open('http://www.telcarnet.com/index.php?mod=members&act=4');
                            }
                        }
                        >
                            <FaRoute className='ms-2 text-big-2' />
                            پنل ردیابی
                        </div>
                        <div className="col-6 link text-left"
                        onClick={this.sendLocationSMS}
                        >

                            موقعیت کنونی
                           <HiOutlineLocationMarker className='me-2 text-big-2' />
                        </div>
                    </div>
                </section>
                <section className="container mt-2 rtl ">
                    <div className="row pt-4">
                        <div className="col-12">
                            <div className="row">
                                <div className="col-2 pt-5 text-center ">
                                   <div className='state-icons'>
                                       {
                                           this.state.isLoaded && this.state.cars[this.state.activeCar].is_active > 0 ?
                                               <CiLock className='ms-2 text-big-2  text-primary-color' /> :
                                               <CiUnlock className='ms-2 text-big-2  text-warning' />
                                       }
                                   </div>
                                    <div className='state-icons'>
                                        {
                                            this.state.connection_type === 'sms' ?

                                                <HiOutlineEnvelope className='ms-2 text-big-2  text-primary-color' />
                                                :
                                                <HiOutlineEnvelope className='ms-2 text-big-2  text-secondary' />
                                        }

                                    </div>
                                    <div className='state-icons'>
                                        {
                                            this.state.isLoaded && this.state.cars[this.state.activeCar].bluetooth  > 0?
                                                <CiBluetooth className='ms-2 text-big-2  text-primary-color' /> :
                                                <CiBluetooth className='ms-2 text-big-2  text-secondary' />
                                        }

                                    </div>
                                    <div className='state-icons'>
                                        {
                                            diff < 5 ?
                                                <BiWifi className='ms-2 text-big-2  text-primary-color' />
                                                :
                                                <BiWifi className='ms-2 text-big-2  text-secondary' />
                                        }

                                    </div>
                                </div>
                                <div className="col-8">
                                    <div className='car-name '>
                                        <IoCarSport className='ms-2 ' />
                                        <select  id="car-list-select"
                                                 value={this.state.activeCar}
                                        onChange={
                                            (val) => {
                                                this.setState({'activeCar': parseInt(val.target.value)})
                                                window.localStorage.setItem("_ac" , parseInt(val.target.value));
                                            }
                                        }
                                        >
                                            {
                                                this.state.cars.map ((car , index) => {

                                                    return (
                                                        <option className="row transaction-item" key={car.car_code} value={index}>
                                                            {car.car_name}
                                                        </option>
                                                    )
                                                })
                                            }
                                        </select>
                                    </div>
                                    {
                                        this.state.isLoaded &&  this.state.cars[this.state.activeCar].shock_sensor === "1" &&
                                        <div className='text-center mb-n3'>
                                            <IoHammerSharp className='text-warning text-big-3 shake' />

                                        </div>
                                    }

                                    {
                                        this.state.isLoaded ?
                                            (this.state.cars[this.state.activeCar].door  > 0 ?
                                            (
                                                this.state.cars[this.state.activeCar].start  > 0 ?
                                                    <img src={HomeCarDoorLight} alt="Home Car " width="100%"/> :
                                                    <img src={HomeCarDoor} alt="Home Car " width="100%"/>
                                            )
                                           :
                                            (
                                                this.state.cars[this.state.activeCar].start  > 0 ?
                                                    <img src={HomeCarLight} alt="Home Car " width="100%"/> :
                                                    <img src={HomeCar} alt="Home Car " width="100%"/>
                                            )
                                            )
                                            :  <img src={HomeCar} alt="Home Car " width="100%"/>
                                    }

                                </div>
                                <div className="col-2 pt-5 text-center ">
                                    <div className='state-icons'>
                                        <CiVolumeMute className='ms-2 text-big-2  text-primary-color' />
                                    </div>

                                    <div className='state-icons'>
                                        {
                                            this.state.isLoaded && this.state.cars[this.state.activeCar].is_conneted_gps > 0 ?
                                                <FaSatelliteDish className='ms-2 text-big-2  text-primary-color' /> :
                                                <FaSatelliteDish className='ms-2 text-big-2  text-secondary' />
                                        }
                                    </div>
                                    <div className='state-icons'>
                                        {
                                            this.state.isLoaded && this.state.cars[this.state.activeCar].is_battery_connected  > 0?
                                                <TbBatteryAutomotive className='ms-2 text-big-2  text-primary-color' /> :
                                                <TbBatteryAutomotive className='ms-2 text-big-2  text-secondary' />
                                        }

                                    </div>
                                    <div className='state-icons'>
                                        {
                                            this.state.isLoaded && this.state.cars[this.state.activeCar].rele  > 0?
                                                <TbCircuitSwitchOpen className='ms-2 text-big-2  text-secondary' /> :
                                                <TbCircuitSwitchClosed className='ms-2 text-big-2 text-primary-color ' />
                                        }

                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </section>
                <section className="container px-4 pt-1 rtl">
                    { (carType === 'R' ) &&
                    <div className="row mb-2"     style={{
                        height: '100px'

                    }}>
                        <div className="col-3">
                            {
                                this.state.engineRun &&  <img src={LoadingCog} alt="Loading" width='35px'/>
                            }


                        </div>
                        <div className="col-6 text-center my-2 " onTouchStart={this.touchStart} onTouchEnd={this.touchEnd}
                        style={{backgroundImage: `url(${Engine})` ,
                        height: '100px',
                            backgroundSize: 'contain',
                            backgroundRepeat : 'no-repeat',
                            backgroundPosition: 'center'

                        }}
                        >
                            &nbsp;
                        </div>
                        <div className="col-3">&nbsp;</div>
                    </div>
                    }
                    <div className="row home-info-part mx-4 ">
                        <div className="col-6  text-right text-white text-small-2 pt-2 ">
                            <BsSpeedometer2 className='ms-2 text-big-2' />
                           سرعت
                        </div>
                        <div className="col-6 link text-left text-small-3 text-white">
                            <strong className='text-big-2 mx-2'>
                                {
                                    this.state.isLoaded && this.state.cars[this.state.activeCar].speed
                                }
                            </strong>
                            <span className='text-small-2'>کیلومتر </span>
                        </div>
                    </div>
                </section>
                <section className="container px-4 pt-2 rtl">
                    <div className="row home-info-part mx-4 ">
                        <div className="col-6  text-right text-white text-small-2 pt-2 ">
                            <GiTwoCoins className='ms-2 text-big-2' />
                           شارژ
                        </div>
                        <div className="col-6 link text-left text-small-3 text-white">
                            <strong className='text-big-2 mx-2'>
                                {currencyFormat.format(
                                    this.state.isLoaded && this.state.cars[this.state.activeCar].sharj
                                )}
                            </strong>
                            <span className='text-small-2'>ریال</span>
                        </div>
                    </div>
                </section>
                <section className="container mt-3 rtl">
                    <div className="row  pt-4 ">
                        <div className="col-4 ">
                            {
                                (carType === 'F' || carType === 'R' )&&
                                <div className='btn-power-around'
                                     onClick={
                                         () => {
                                             const command = `open`;
                                             this.sendToSocket(command);

                                         }
                                     }
                                >
                                    <TbCarCrash className=' text-big-2 text-primary-color' />
                                </div>
                            }

                            <div className='btn-power-around'
                                 onClick={
                                     () => {
                                         const command = `dis`;
                                         this.sendToSocket(command);

                                     }
                                 }
                            >
                                <RxLockOpen1 className=' text-big-2 text-primary-color' />
                            </div>

                        </div>
                        {
                            (carType === 'S' || carType === 'K' || carType === 'F' || carType === 'R' ) ?
                                <div className="col-4 text-center"
                                     id='powerBTN'
                                     onClick={
                                         () => {
                                             this.setState({showModalPower : true})
                                         }

                                     }


                                >
                                    <img src={PowerBTN} alt="Power" className='w-100 opacity-75'/>
                                </div>
                                :
                                <div className="col-4 text-center">&nbsp;</div>
                        }

                        <div className="col-4">
                            {
                                (carType === 'F' || carType === 'R' )&&
                            <div className='btn-power-around'
                                 onClick={
                                     () => {
                                         const command = `mof`;
                                         this.sendToSocket(command);

                                     }
                                 }
                            >
                                <IoVolumeMute className=' text-big-2 text-primary-color' />
                            </div>
                            }
                            <div className='btn-power-around'
                                 onClick={
                                     () => {
                                         const command = `act`;
                                         this.sendToSocket(command);
                                         this.setState({showModalSpeed: false})
                                     }
                                 }
                            >
                                <RxLockClosed className=' text-big-2 text-primary-color' />
                            </div>
                        </div>

                    </div>
                </section>

                <Navbar />
            </React.Fragment>
        );
    }
    componentDidMount = () => {
        window.localStorage.removeItem("_trk" );
        const mobile = window.localStorage.getItem("mobile");
        const password = window.localStorage.getItem("password");
        if(!mobile && !password ) {
                window.location.replace('/')
        }
        const SP = window.localStorage.getItem("_sP");
        const oldPass = window.localStorage.getItem("_fToken");
        if(oldPass && !SP) {
            window.location.replace('/')
        }
        window.localStorage.removeItem("_sP")
        API.getCarData(mobile,password)
            .then((response) => {
                this.setState({isLoaded: true, 'cars': response.car_act})
                setTimeout(() => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                }, 400)
            })
         callServiceInterval = setInterval (() => {
            const mobile = window.localStorage.getItem("mobile");
            const password = window.localStorage.getItem("password");
            API.getCarData(mobile,password)
                .then((response) => {
                    this.setState({'cars': response.car_act})
                })
        },7000)

    }
    componentWillUnmount() {
        clearInterval(callServiceInterval);
    }


}

export default Home;